<template>
  <div v-if="graduatedPrices[0]">
    <b>{{ $translate("Ceres::Template.singleItemGraduatedPrices") }}:</b>
    <table class="graduated-prices-table">
      <tr
        v-for="(price, index) in graduatedPrices"
        :key="index"
      >
        <td
          :class="paddingClasses"
          :style="paddingInlineStyles"
        >
          {{ $translate("Ceres::Template.singleItemMinimumQuantity") }} {{ price.minimumOrderQuantity }}
        </td>
        <td
          :class="paddingClasses"
          :style="paddingInlineStyles"
        >
          {{ price.unitPrice.formatted }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {

  name: 'MatrixGraduatedPrices',

  inject: {
    itemId: {
      default: null
    }
  },

  props: {
    paddingClasses: {
      type: String
    },
    paddingInlineStyles: {
      type: String
    }
  },

  computed:
    {
      graduatedPrices () {
        const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`];

        let prices = currentVariation && currentVariation.prices.graduatedPrices;
        const minQuantity = currentVariation && currentVariation.variation.minimumOrderQuantity;

        prices = prices.filter(price => price.minimumOrderQuantity > minQuantity);

        return [...prices].sort((priceA, priceB) => {
          return priceA.minimumOrderQuantity - priceB.minimumOrderQuantity;
        });
      }
    }
};
</script>
